"use client";
import { jsx } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Alert as Alert$1 } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/Alert.css';const root = "_root_1jrey_2";
const message = "_message_1jrey_11";
const AlertStyles = {
  root,
  message
};
const _Alert = forwardRef((props, ref) => {
  const { text, icon, type, variant, mod, ...rest } = props;
  let formattedIcon = icon && /* @__PURE__ */ jsx(Icon, { name: icon, color: variant === "light" ? "black" : "light" });
  switch (type) {
    case "warning":
      formattedIcon = /* @__PURE__ */ jsx(Icon, { name: "AlertCircle", color: variant === "light" ? "warning" : "black" });
      break;
    case "error":
      formattedIcon = /* @__PURE__ */ jsx(Icon, { name: "X", color: variant === "light" ? "error" : "light" });
      break;
    case "success":
      formattedIcon = /* @__PURE__ */ jsx(Icon, { name: "CircleCheck", color: variant === "light" ? "success" : "light" });
      break;
    case "important":
      formattedIcon = /* @__PURE__ */ jsx(Icon, { name: "InfoCircle", color: variant === "light" ? "dark" : "light" });
      break;
  }
  return /* @__PURE__ */ jsx(
    Alert$1,
    {
      ...rest,
      icon: formattedIcon,
      classNames: AlertStyles,
      variant: "filled",
      radius: "md",
      ref,
      px: "md",
      mod: { type, variant, ...mod },
      children: text
    }
  );
});
_Alert.displayName = "Alert";
const Alert = sharedHandler(_Alert);
Alert.displayName = _Alert.displayName;
export {
  AlertStyles as A,
  Alert as default
};
